import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';

@Injectable({
  providedIn: 'root'
})
export class FormItemDateTypeService extends BaseDatabaseService{

  private collectionName = 'formItemDateType';

  constructor() {
    super();
  }

  getFormItemDateType() {
    return this.db.collection(this.collectionName).get();
  }
}
